import { getTranslate } from '../../localization'

// "48 hours" — the cut-off is stored and edited in whole hours before check-in.
export const formatCutoff = (hours: number): string =>
  `${hours} ${getTranslate('hours')}`
